import { scroller } from 'react-scroll';

const useScrollToFooter = () => () => scroller.scrollTo('contact', {
  duration: 800,
  delay: 0,
  smooth: 'easeInOutQuart',
  offset: -119,
});

const useScrollToTop = () => () => scroller.scrollToTop();

export default useScrollToFooter;
